<template>
  <div class="formulaListCenter" v-loading="loading">
    <div class="header">
      <span v-show="detail.payStatus=='3'" class="iconfont formula-status colorF54A icon-yituif"></span>
      <div class="header_left">
        <div class="header_left_title">配方单</div>
        <!-- 产品要求要展示为唯一编码 -->
        <div class="header_left_order">{{detail.prescriptionCode}}</div>
        <div class="header_left_order">{{detail.prescriptionId}}</div>
      </div>
      <div class="header_right">
        <template  >
          <el-button v-show="detail.status === 1 && detail.payStatus !== 3" v-for="(item) in areaList" :key="item.value" type="primary" class="header_right_btn" @click="receiveFormula(item.value)">收方{{ item.value }}</el-button>
        </template>
        <el-button class="header_right_btn" v-show="detail.status=='1' && detail.originalDeptId!=deptId && detail.payStatus!='3'" @click="refuseFormula">拒绝</el-button>
        <el-dropdown trigger="click" @command="toPrint($event,false)">
          <el-button class="header_right_btn">打印</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="prescription" v-show="detail.recipeType !== 0">处方</el-dropdown-item>
            <el-dropdown-item command="receipt">收费小票</el-dropdown-item>
            <el-dropdown-item command="formula">配方单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="header_right_btn traceCodes_btn" :class="detail.traceStatus ? 'traceCodes_btn_error' : 'traceCodes_btn_success'" v-if="detail.prescriptionCode" @click="showTraceability">
          <img :src="detail.traceStatus ? imgArr.traceCodesError : imgArr.traceCodesSuccess" class="traceCodes_icon"/>
          <div>追溯码</div>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 患者信息 -->
      <div class="user">
        <div class="user_info">
          <span :class="{ 'iconfont': true, 'icon-yonghu': true, 'user_info_icon': true, 'sex_woman': detail.patientInfo.sex == 1 }"></span>
          <div class="user_info_name">{{ detail.patientInfo.name }}</div>
          <div class="user_info_sex">{{ detail.patientInfo.sex === '0' ? '男' : '女' }}</div>
          <div class="user_info_age">{{ detail.patientInfo.age }}岁 {{detail.patientInfo.month}}月</div>
          <div class="user_info_phone">{{ detail.patientInfo.phone }}</div>
        </div>
        <div class="user_right">
          <!-- <el-radio-group v-model="detail.areaId" class="radio_group" v-if="detail.status === 1 && detail.payStatus !== 3">
            <el-radio v-for="item in areaList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group> -->
          <div class="user_formula">该患者配方单数量：{{detail.patientInfo.prescriptionNum}}</div>
        </div>
      </div>
      <!-- 处理配送信息 -->
      <div class="handle">
        <div class="handle_item" v-if='detail.handlingWay'>
          <div class="handle_item_label">加工</div>
          <div class="handle_item_value">
            {{detail.handlingWay}}，
            <span v-if="detail.handlingWay=='熬药'" >每剂{{detail.prescriptionNum}}袋，共{{detail.prescriptionTotalNum}}袋，{{detail.prescriptionSpecsNum}}</span>
            <div v-if="detail.waterAddition" class="ml16">加水量：{{ detail.waterAddition }}ml</div>
            <div v-if="detail.processStatus === 1" class="handle_refund">{{ detail.recipeType === 5 ? `已退${detail.dosageRefund}剂` : '已退' }}</div>
          </div>
        </div>
        <div class="handle_item">
          <div class="handle_item_label">{{detail.deliveryWayName}}</div>
          <div class="handle_item_value" v-if="detail.deliveryInfo">{{detail.deliveryInfo.consigneeName}}，{{detail.deliveryInfo.phone}}，{{detail.deliveryInfo.detailedAddress}}<div v-if="detail.deliveryInfo && detail.deliveryInfo.status === 1" class="handle_refund">已退</div></div>
          <!-- 填写快递信息 -->
          <div class="handle_item_order" v-if="detail.deliveryWay === 1 && detail.deliveryInfo">
            <div v-if="!detail.deliveryInfo.deliveryNumber && detail.payStatus !== 3 && (detail.deliveryInfo || {}).status !== 1" class="order_text" @click="showOrHideTransportDialogHandle($event, true)">
              <span class="el-icon-edit order_text_empty_icon"></span>
              <span class="order_text_empty_text">填写快递单号</span>
            </div> 
          </div>
        </div>
        <div v-if="detail.deliveryInfo.deliveryNumber" class="handle_item transport-info">
          <div class="transport-info">
            <span>{{ transportInfo.orderInfo.companyName || '' }}-{{ transportInfo.orderInfo.trackingNumber || '' }}{{ transportInfo.orderInfo.timeVal ? ('-' + (transportInfo.orderInfo.timeVal || '') + '发货') : '' }}</span>
            <i
              class="el-icon-edit-outline"
              v-if="detail.payStatus !== 3 && (detail.deliveryInfo || {}).status !== 1"
              style="margin-left: 10px;color: #1890FF;cursor: pointer"
              @click="showOrHideTransportDialogHandle($event, true, true)"
            ></i>
          </div>
          <el-popover
            popper-class="formula_popover transport-popover"
            placement="right-start"
            width="270"
            trigger="click"
            @show="transportInfo.showPopover = true"
            @hide="transportInfo.copyInfo.showToolTip = transportInfo.showPopover = false"
          >
            <div class="transport-detail">
              <div class="transport-detail-title">
                <span>{{ transportInfo.orderInfo.companyName || '' }}：{{ detail.deliveryInfo.deliveryNumber }}</span>
                <el-tooltip placement="top" manual :value='transportInfo.copyInfo.showToolTip'>
                  <div slot="content">复制成功</div>
                  <i class="icon el-icon-copy-document" :class="{ active: transportInfo.copyInfo.showToolTip }" @click="copyTransportNumHandle(detail.deliveryInfo.deliveryNumber)"></i>
                </el-tooltip>
              </div>
              <div v-if="transportInfo.transportStepInfoList.length > 0" class="transport-detail-content">
                <div
                  class="transport-detail-content-item"
                  v-for="(item, index) in transportInfo.transportStepInfoList"
                  :key="index"
                >
                  <div class="transport-detail-content-item-title">{{ item.acceptStation || '' }}</div>
                  <div class="transport-detail-content-item-time">{{ item.acceptTime || '' }}</div>
                </div>
              </div>
              <div v-else class="transport-detail-content mt10 ml10">
                暂未查询到相关物流信息
              </div>
            </div>
            <span slot="reference" class="order_text_empty_text" @click="getTransportDetail(detail.deliveryInfo.deliveryNumber)">查看物流</span>
          </el-popover>
        </div>
      </div>
      <!-- 处方信息 -->
      <div class="prescription">
        <el-table
          class="prescription_table"
          :header-cell-class-name="prescriptionTableHeader"
          :cell-class-name="prescriptionTableCell"
          :data="detail.drugInfos"
          style="width: 100%">
          <el-table-column type="index" width="40" align="center"></el-table-column>
          <el-table-column prop="date" :label="computedRecipeName(detail)">
            <template slot-scope="scope">
                <div class="flex align-i-c">
                  <div class="size14 color1F23 mr2">{{ detail.recipeType == '5' ? scope.row.drugName : scope.row.spuCommonName}}</div>
                  <div class="size12 color6671" v-if="scope.row.drugType === 0">饮片</div>
                  <div class="size12 color6671" v-if="scope.row.drugType === 1">颗粒</div>
                  <div v-if="scope.row.isOwned && scope.row.isOwned=='1'" class="size12 color6671">【自备】</div>
                  <div v-if="scope.row.status === 1 || scope.row.drugNumRefund > 0" class="refund-icon">
                    <span v-if="detail.recipeType == '5'">已退{{ countDosageRefund(scope.row) }}剂</span>
                    <span v-if="detail.recipeType == '1' || detail.recipeType == '4'">已退{{ countDosageRefund(scope.row) }}剂{{ scope.row.drugNumRefund }}{{ scope.row.unit }}</span>
                    <span v-if="detail.recipeType == '0'">已退{{ scope.row.drugNumRefund }}{{ scope.row.unit }}</span>
                  </div>
                </div>
            </template>
          </el-table-column>
          <el-table-column prop="handling" label="煎法" width="100"></el-table-column>
          <el-table-column prop="specifications" label="规格" width="100"></el-table-column>
          <el-table-column prop="manufacturer" label="厂家" show-overflow-tooltip></el-table-column>
          <el-table-column prop="drugPieceNumName" label="数量" width="160"></el-table-column>
          <!-- <el-table-column prop="price" label="单价" width="80"></el-table-column> -->
          <!-- <el-table-column prop="totalPrice" label="小计" width="80"></el-table-column> -->
        </el-table>
        <div class="prescription_parameter">
          <div class="prescription_parameter_left">
            <div v-if="[1, 5].includes(detail.recipeType)">{{ detail.dosage || 1 }}剂</div>
            <div v-if="detail.orderCaseProjectRecipeResp" class="prescription_parameter_left_list">
              <div v-if="detail.orderCaseProjectRecipeResp.recipeMethod">，{{ detail.orderCaseProjectRecipeResp.recipeMethod }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.doseFrequency">，{{ detail.orderCaseProjectRecipeResp.doseFrequency }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.frequency">，{{ detail.orderCaseProjectRecipeResp.frequency }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.takingDosage">，{{ detail.orderCaseProjectRecipeResp.takingDosage }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.mixingBagNum">，每次{{ detail.orderCaseProjectRecipeResp.mixingBagNum }}袋</div>
              <div v-if="detail.orderCaseProjectRecipeResp.creamDosage">，{{ detail.orderCaseProjectRecipeResp.creamDosage }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.pelletizingDosage">，{{ detail.orderCaseProjectRecipeResp.pelletizingDosage }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.bakingPowderDosage">，{{ detail.orderCaseProjectRecipeResp.bakingPowderDosage }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.takingDays">，{{ detail.orderCaseProjectRecipeResp.takingDays }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.recipeMoment">，{{ detail.orderCaseProjectRecipeResp.recipeMoment }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.applicationTime">，{{ detail.orderCaseProjectRecipeResp.applicationTime }}</div>
              <div v-if="detail.orderCaseProjectRecipeResp.wrapTime">，{{ detail.orderCaseProjectRecipeResp.wrapTime }}</div>
            </div>
          </div>
          <div class="prescription_parameter_right">
            <span v-if="[1].includes(detail.recipeType)">单剂{{ detail.drugWeightTotal || 0 }}g</span>
            <span v-if="[1].includes(detail.recipeType)">，合计{{ computedMultiplication( detail.drugWeightTotal,detail.dosage) }}g</span>
            <!-- <strong>，总价：¥{{ countTotalPrice(detail.drugInfos) }}</strong> -->
          </div>
        </div>
        <div class="prescription_remarks">
          <div class="prescription_remarks_label">配方单备注</div>
          <div class="prescription_remarks_value">{{ detail.remark }}</div>
        </div>
      </div>
      <!-- 其他信息 -->
      <div class="other">
        <div class="other_label">医嘱事项</div>
        <div class="other_value">{{ detail.doctorAdvice }}</div>
      </div>
      <div class="other">
        <div class="other_label">备注信息</div>
        <div class="other_value">
          <div v-if="detail.patientRemark">【患者】{{ detail.patientRemark }}</div>
          <div v-if="detail.deptRemark">【医馆】{{ detail.deptRemark }}</div>
        </div>
      </div>
    </div>
    <!-- 打印 -->
    <printDialog
      ref="printDia"
      v-show="print.printDialogShow"
      :printDialogShow="print.printDialogShow"
      :isBatch="print.isBatch"
      :printListObj="print.printListObj"
      :id="print.printOrderId"
      :areaId="detail.areaId"
      :orderType="print.orderType"
      :printType="print.printType"
      @closePrintPrescription="closePrintPrescription"
      @printSuccess="printSuccess"
      @setPrintDiaShow="setPrintDiaShow">
    </printDialog>
    <custom-dialog :title="refuseDialog.title" :width="refuseDialog.width" v-if="refuseDialog.dialogShow" :visible="refuseDialog.dialogShow" @close="refuseDialogClose" @save="refuseDialogSave">
      <div slot="content">
        <el-input type="textarea" v-model.trim="refuseDialog.remark" placeholder="请填写拒绝原因" :rows="4" resize="none"></el-input>
      </div>
    </custom-dialog>
    <!-- 追溯码弹窗 -->
    <custom-dialog
      title="追溯码查看"
      width="800px"
      v-if="traceability.dialogShow"
      :visible="traceability.dialogShow"
      cancelBtnTitle="关闭"
      :isShowConfirmBtn="false"
      @close="closeTraceability"
    >
      <div slot="content">
        <CustomTable
          v-loading="traceability.loading"
          :column="traceability.listTable"
          :tableData="traceability.drugList"
          :max-height="traceability.tableHeight"
          border
        >
          <template slot="quantity" slot-scope="{row}">
            {{row.drugNumRemain}}{{row.unit || ''}}
          </template>
          <!-- 追溯码 -->
          <template slot="traceabilityCode" slot-scope="{row}">
            <template v-if="row.traceCodes && row.traceCodes.length > 0">
              <span
                class="trace-item"
                v-for="(item, index) in (row.traceCodes || [])"
                :key="index"
              >
                {{item}}{{index < row.traceCodes.length - 1 ? '、' : ''}}
              </span>
            </template>
            <span v-else class="trace-item-empty">{{ row.splitFlag == 0 ? '暂未录入' : '无需录入' }}</span>
          </template>
        </CustomTable>
      </div>
    </custom-dialog>

    <!-- 填写快递信息弹窗 -->
    <custom-dialog
      :title="(detail.deliveryInfo.deliveryNumber ? '编辑' : '填写') + '物流信息'"
      width="600px"
      v-if="transportInfo.dialogShow"
      :visible="transportInfo.dialogShow"
      :saveLoading="transportInfo.loading"
      @save="saveTransportInfoHandle($event)"
      @close="showOrHideTransportDialogHandle($event, false)"
    >
      <div slot="content">
        <el-form
          label-width="90px"
          :model="transportInfo.formData"
          ref="transportInfoFormRef"
          :rules="transportInfo.rules"
        >
          <el-form-item
            label="快递公司"
            prop="transportCompanyVal"
          >
            <el-select
              v-model="transportInfo.formData.transportCompanyVal"
              placeholder="请选择快递公司"
              clearable
              style="width: 100%;"
            >
              <el-option
                v-for="item in transportInfo.transportCompanyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="快递单号"
            prop="transportNo"
          >
            <el-input
              v-model="transportInfo.formData.transportNo"
              placeholder="请输入快递单号"
              maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="发货时间">
            <el-select
              v-model="transportInfo.formData.transportTime"
              placeholder="请选择发货时间"
              style="width: 100%;"
            >
              <el-option
                v-for="(item, index) in transportInfo.transportTimeList"
                :key="index"
                :disabled="item.enableStatus !== 1"
                :label="(item.deliveryTimeHour || '') + ':' + (item.deliveryTimeMinute || '00')"
                :value="(item.deliveryTimeHour || '') + ':' + (item.deliveryTimeMinute || '00')"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </custom-dialog>
    <custom-dialog title="请选择药品配方区" width="500px" v-if="areaDialogShow" :visible="areaDialogShow" @close="areaDialogClose" @save="areaDialogConfirm">
      <div slot="content">
        <div class="flex ">
          <div>选择配方区</div>
          <el-radio-group v-model="detail.areaId" class="ml16">
            <el-radio v-for="item in areaList" :key="item.value" :label="item.value">{{item.label}}</el-radio>
          </el-radio-group>
        </div>
      </div>
    </custom-dialog>>
  </div>
</template>

<script>
import { formulaDTO } from '@/DTO/index'
import { getTraceDrugList } from "@/api/formula"
import { getCompany } from "@/api/delivery"
import { isNull, copy } from '@/utils/validateBase'
import printDialog from '@/components/printDialog'
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomTable from '@/components/CustomTable.vue'
import session from '@/utils/session'
import { imgArr } from '@/assets/images/img.js'
import { queryHospDrug } from '@/api/pricingDetails.js'
  export default {
    name: 'FormulaListCenter',
    components: {
      printDialog,
      CustomDialog,
      CustomTable
    },
    props:{
      prescriptionId:{
        type:String,
        default:''
      },
      detail: {
        type: Object,
        default: function() {
          return {
            patientInfo: {},
            orderCaseProjectRecipeResp: {},
            drugInfos: [],
            deliveryInfo: {}
          }
        }
      }
    },
    data() {
      // 校验输入的快递单号
      const validateTransportNo = (rule, value, callback) => {
        value = value || ''
        if (value.length < 5) {
          return callback(new Error('快递单号长度不能少于5位'))
        } else if (value.replaceAll(' ', '').length !== value.length) {
          return callback(new Error('快递单号中不能包含空格'))
        } else {
          callback()
        }
      }
      return {
        imgArr:imgArr,
        deptId:session.get('deptId'),
        loading:false,
        print:{
          printDialogShow:false, // 打印弹框
          isBatch: false, // 是否批量打印
          printListObj: [], // 批量打印列表
          orderType: '', // 打印处方订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
          printType: '', // 打印类型 1小票 2处方
          printOrderId: '', // 打印单号
        },
        refuseDialog:{
          title: '拒绝配方单',
          dialogShow: false,
          width: '445px',
          remark: '', // 备注
        },

        // 追溯码弹窗
        traceability: {
          dialogShow: false,
          loading: false,
          listTable: [
            { label: "药品名称", prop: "spuCommonName", width: '200', align: 'left' },
            { label: "数量", prop: "id", slotName: 'quantity', minWidth: "120", align: 'left' },
            { label: "追溯码", prop: "drugName", slotName:'traceabilityCode', minWidth: "350", align: 'left' },
          ],
          drugList: [],
          tableHeight: 0
        },

        // 物流信息
        transportInfo: {
          orderInfo: {}, // 配方单页面物流信息（通过接口请求回来的物流信息）
          // 填写物流信息
          dialogShow: false, // 显示物流信息弹窗
          loading: false,
          formData: {
            transportCompanyVal: '', // 物流公司
            transportNo: '', // 快递单号
            transportTime: '', // 发货时间
          },
          transportCompanyList: [],
          transportTimeList: [],
          rules: {
            transportCompanyVal: [
              { required: true, message: '请选择快递公司', trigger: 'change' }
            ],
            transportNo: [
              { required: true, message: '请输入快递单号', trigger: 'change' },
              { validator: validateTransportNo, trigger: 'blur' }
            ]
          }, 

          // 物流详情
          transportStepInfoList: [],
          showPopover: false, // 快递追踪信息popover是否是属于展示状态
          copyInfo: {
            showToolTip: false
          },
        },
        areaList: [],
        areaDialogShow:false
      }
    },
    computed:{
      // 乘法
      computedMultiplication() {
        return function (drugWeightTotal,dosage) {
          const doseNum = dosage  || 1;
          const weight = drugWeightTotal || 0;
          return this.$bigNumber(doseNum, '*', weight,2)
        }
      },
      //显示处方名字
      computedRecipeName(){
        return function(detail){
          let str = ''
          switch(detail.recipeType){
            case 0:
              str= '非处方项目';
              break;
            case 1:
              str= '中药处方';
              break;
            case 4:
              str= '中成药处方';
              break;
            case 5:
              str= `医联产品`;
              break;
          }
          return str;
        }
      },
      // 计算已退剂
      countDosageRefund() {
        return (row) => {
          return this.$bigNumber(isNull(row.drugNumRefund) ? 0 : row.drugNumRefund, '/', row.drugPieceNum)
        }
      },
      // 合计小计
      countTotalPrice() {
        return (list) => {
          let total = list.reduce((a, b) => {
            return this.$bigNumber(a, '+', b.totalPrice)
          }, 0);
          total = Math.round(total * 100) / 100;
          return total;
        }
      },
      
    },

    created() {
      this.traceability.tableHeight = document.documentElement.clientHeight - 290
      this.areaList = this.getAreaList()
    },
    methods: {
      // 处方表格表头类
      prescriptionTableHeader({row, column, rowIndex, columnIndex }) {
        if (columnIndex == '1') {
          return 'prescription_table_header_keynote'
        } else {
          return 'prescription_table_header_default'
        }
      },
      // 处方表格单元格类
      prescriptionTableCell({ row, column }) {
        let cellClass = {
          'prescription_table_cell': true,
          'keynote': false
        }
        if (column.type === 'index' || ['煎法', '数量'].includes(column.label)) {
          cellClass['keynote'] = true;
        }
        const result = Object.keys(cellClass).filter(key => { return cellClass[key] });
        return result.join(' ');
      },
      // 收方
      async receiveFormula(areaId){
        this.detail.areaId = areaId
        let { code } = await formulaDTO.receiveFormula({prescriptionId:this.prescriptionId,deptId:this.deptId,requestId:this.$moment().valueOf(),areaId:this.detail.areaId})
        if( code === 200 ){
          this.$emit('refreshList', false, () => {
            const artNoList = this.detail.drugInfos.map(v => { return v.artNo })
            const specialList = ['20023048', '20023049', '9900194', '9900196', '9900197', '9900199']
            const noNeedPrint = artNoList.every(v => specialList.includes(v))
            if (!(this.detail.recipeType === 0 & noNeedPrint) || this.deptId === 127) {
              this.toPrint('formula');
            }
            if (this.deptId === 127 & [1, 4].includes(this.detail.recipeType)){
              this.toPrint('prescription');
            }
          })
        }
      },
      // 拒绝
      refuseFormula() {
        this.refuseDialog.dialogShow = true;
      },
      // 拒绝配方
      async refuseDialogSave(){
        if(isNull(this.refuseDialog.remark)){
          return this.$message.error('请填写拒绝原因')
        }
        let { code } = await formulaDTO.refuseFormula({ prescriptionId: this.prescriptionId, remark: this.refuseDialog.remark,deptId:this.deptId,requestId:this.$moment().valueOf() });
        if(code === 200){
          this.$emit('refreshList',true);
          this.refuseDialogClose()
        }
      },
      // 关闭拒绝弹框
      refuseDialogClose(){
        this.refuseDialog.dialogShow = false;
        this.refuseDialog.remark=''
      },
      // 打印弹窗展示
      setPrintDiaShow() {
        this.print.printDialogShow = true;
      },
      // 取消打印
      closePrintPrescription() {
        this.print.printDialogShow = false;
      },

      // 展示填写物流信息弹窗
      showOrHideTransportDialogHandle(event, value, isEdit = false) {
        if (value) {
          // 打开弹窗，获取相关信息
          this.getCompanyList()
          this.getTransPortTimeList()
          if (isEdit) {
            this.transportInfo.formData.transportCompanyVal = this.transportInfo.orderInfo.companyCode || ''
            this.transportInfo.formData.transportNo = this.transportInfo.orderInfo.trackingNumber || ''
            if (this.transportInfo.orderInfo.timeVal) {
              this.transportInfo.formData.transportTime = (this.transportInfo.orderInfo.deliveryTimeHour || '') + ':' + (this.transportInfo.orderInfo.deliveryTimeMinute || '00')
            } else {
              this.transportInfo.formData.transportTime = ''
            }
          } else {
            this.transportInfo.formData.transportCompanyVal = ''
            this.transportInfo.formData.transportNo = ''
            this.transportInfo.formData.transportTime = ''
          }
        } else {
          // 关闭弹窗
          const transportInfoFormRef = this.$refs.transportInfoFormRef
          if (transportInfoFormRef) {
            transportInfoFormRef.resetFields()
          }
          this.transportInfo.loading = false
        }
        this.transportInfo.dialogShow = value
      },
      // 保存物流信息
      saveTransportInfoHandle(event) {
        const transportInfoFormRef = this.$refs.transportInfoFormRef
        if (transportInfoFormRef) {
          transportInfoFormRef.validate(async valid => {
            if (valid) {
              const params = {
                orderId: this.detail.orderId,
                requestId: new Date().getTime(),
                prescriptionId: this.prescriptionId,
                deliveryNumber: this.transportInfo.formData.transportNo || '',
                deptId: this.deptId,
                companyCode: this.transportInfo.formData.transportCompanyVal || '',
                deliveryTimeHour: this.transportInfo.formData.transportTime ? this.transportInfo.formData.transportTime.split(':')[0] : '',  // 时
                deliveryTimeMinute: this.transportInfo.formData.transportTime ? this.transportInfo.formData.transportTime.split(':')[1] : '', // 分
                deliveryTimeSecond: '' // 秒
              }
              this.transportInfo.loading = true
              const res = await formulaDTO.upDateDeliveryNumber(params)
              if (res.code == 200) {
                this.$message.success('保存成功!')
                this.$emit('getDetail')
                this.showOrHideTransportDialogHandle(event, false)
                // this.getTransportInfo()
              } else {
                this.transportInfo.loading = false
              }
            }
          })
        }
      },

      /**
      * 获取物流公司
      */
      async getCompanyList() {
        let { code, data } = await getCompany();
        if (code == 200) {
          this.transportInfo.transportCompanyList = (data || []).map((item, index) => ({
            ...item,
            label: item.name,
            value: item.companyCode || index
          }))
        }
      },

      // 获取物流发货时间列表
      async getTransPortTimeList() {
        const res = await formulaDTO.getTransPortOrderTimeList()
        if (res.code === 200) {
          this.transportInfo.transportTimeList = res.data || []
        }
      },

      // 获取物流跟踪信息详情
      async getTransportDetail(logisticCode = '') {
        // 如果物流信息是展开的，则不用再次请求
        if (this.transportInfo.showPopover) return

        this.transportInfo.transportStepInfoList = []
        const params = {
          prescriptionId: this.prescriptionId,
          logisticCode
        }
        const res = await formulaDTO.getTransPortStepDetail(params)
        if (res.code === 200) {
          if (res.data.success === 1) {
            this.transportInfo.transportStepInfoList = res.data.traces || []
          }
        }
      },

      // 获取物流单信息
      async getTransportInfo() {
        const params = {
          prescriptionId: this.prescriptionId
        }
        if (!params.prescriptionId) return
        const res = await formulaDTO.getTransportOrderInfo(params)
        if (res.code === 200) {
          this.transportInfo.orderInfo = res.data || {}
          const { deliveryTimeHour, deliveryTimeMinute } = this.transportInfo.orderInfo
          if (deliveryTimeHour || deliveryTimeMinute) {
            // 发货时间
            this.transportInfo.orderInfo.timeVal = deliveryTimeHour + ':' + (deliveryTimeMinute || '00')
          } else {
            this.transportInfo.orderInfo.timeVal = ''
          }
        }
      },

      // 复制物流单号
      copyTransportNumHandle(transportNum = '') {
        copy(transportNum, true)
        this.transportInfo.copyInfo.showToolTip = true
        setTimeout(() => {
          this.transportInfo.copyInfo.showToolTip = false
        }, 2000)
      },
      
      // 打印配方单 flag 是否直接打印
      toPrint(type,flag=true) {
        switch(type) {
          case 'prescription':
            this.print.isBatch = false;
            this.print.printType = '2'
            this.print.orderType = '1'
            this.print.printOrderId = this.detail.recipeDrugId
            this.$nextTick(() => {
              this.$refs.printDia.useDefaultPrint({
                printType: '2',
                orderType: '1',
                id: this.detail.recipeDrugId
              })
            })
            break;
          case 'receipt':
            this.print.isBatch = false;
            this.print.printType = '1'
            this.print.orderType = '4'
            this.print.printOrderId = this.detail.orderId
            this.$nextTick(() => {
              this.$refs.printDia.useDefaultPrint({
                printType: '1',
                orderType: '4',
                id: this.detail.orderId
              })
            })
            break;
          case 'formula':
            if (this.detail.status === 1) {
              this.$message.warning('请收方后打印')
            } else {
              if(flag){
                this.print.isBatch = false;
                this.print.printType = '9'
                this.print.orderType = '16'
                this.print.printOrderId = this.prescriptionId
                this.$nextTick(() => {
                  this.$refs.printDia.useDefaultPrint({
                    printType: '9',
                    orderType: '16',
                    id: this.prescriptionId,
                    areaId:this.detail.areaId
                  })
                })
              }else{
                let recipeAreasNum = this.$session.get('deptInfo').recipeAreasNum || 1
                if( recipeAreasNum > 1 ){
                  this.areaDialogShow = true
                }else{
                  this.toPrint('formula',true)
                }
              }
            }
            break;
        }
      },
      //打印成功
      printSuccess(){
        this.$emit('getDetail');
      },

      // 追溯码弹窗展示
      showTraceability() {
        this.traceability.dialogShow = true
        this.getTraceDrugListInfo()
        
      },

      // 获取追溯码药品列表
      async getTraceDrugListInfo() {
        const params = {
          prescription_id: this.prescriptionId
        }
        try {
          const res = await getTraceDrugList(params)
          if(res.code === 200) {
            res.data && res.data.forEach(item=>{
              item.traceCodes = isNull(item.traceCodes) ? [] : item.traceCodes.split(',')
            })
            this.traceability.drugList = res.data || []
          } else {
            this.$message.error(res.message)
          }
        } catch (error) {
          console.log('获取追溯码药品列表数据请求失败', error)
        }
      },

      // 关闭追溯码弹框
      closeTraceability() {
        this.traceability.dialogShow = false
      },
      //查询配方单追溯码
      async queryHospDrug(list) {
        let productNumber = []
        list.forEach(item=>{
          productNumber.push(item.artNo)
        })
        let { data ,code} = await queryHospDrug({productNumber,deptId:this.detail.originalDeptId})
        if(code==200){
          data && data.forEach(v1=>{
            this.detail.drugInfos.forEach(v2=>{
              if(v1.id === v2.artNo){
                v2.traceStatus = v1.traceStatus
                v2.splitFlag = v1.splitFlag
              }
            })
          })
          this.detail.traceStatus = this.computedTraceCodes();
          this.$forceUpdate()   
        }
      },
      computedTraceCodes(){
        let flag = false;
        this.detail.drugInfos.forEach(v=>{
          if(v.traceStatus == '1' && v.splitFlag == 0 && isNull(v.traceCodes)){
            flag = true;
            return;
          }
        })
        return flag;
      },
      getAreaList(){
        let recipeAreasNum = this.$session.get('deptInfo').recipeAreasNum || 1
        let arr = []
        const numText = {1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '七', 8: '八', 9: '九', 10: '十'}
        for (let i = 1; i <= recipeAreasNum; i++) {
          arr.push({label:`配方区${numText[i]}`,value:i+''})
        }
        return arr;
      },
      areaDialogClose(){
        this.areaDialogShow = false
      },
      areaDialogConfirm(){
        this.areaDialogShow = false
        this.toPrint('formula')
      }
    },
    watch: {
      // prescriptionId() {
      //   this.getTransportInfo()
      // }
    }
  }
</script>

<style lang="less" scoped>
  .formulaListCenter{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .header{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 56px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #E0E0E0;
    position: relative;
  }
  .formula-status{
    font-size: 64px;
    position: absolute;
    top: 0;
    left: 230px;
    z-index: 2;
  }
  .header_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_left_title{
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .header_left_order{
    margin: 0 0 0 12px;
    font-size: 14px;
    color: #000000;
  }

  .header_right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .header_right_btn{
    margin: 0 0 0 8px;
  }
  .traceCodes_btn{
    width: 84px;
    height: 32px;
    color:#000;
    font-size: 14px;
    border-radius: 2px 2px 2px 2px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .traceCodes_btn_success{
    background: #E2F8E0;
    border: 1px solid #29C01B;
  }
  .traceCodes_btn_error{
    background: #FFF0E1;
    border: 1px solid #FE8F1F;
  }
  .traceCodes_icon{
    width:12px;
    height:12px;
    margin-right: 4px;
  }
  .content{
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    height: calc( 100% - 56px );
    overflow-x: hidden;
    overflow-y: auto;
  }

  .user{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    overflow: hidden;
  }

  .user_info{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    height: 36px;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
  }
  
  .user_info_icon{
    font-size: 10px;
    color: #1890FF;
  }
  
  .user_info_icon.sex_woman{
    color: #FF3194;
  }

  .user_info_name{
    margin: 0 0 0 8px;
    width: 72px;
    font-size: 14px;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .user_info_sex{
    margin: 0 0 0 16px;
    font-size: 14px;
    color: #000000;
  }

  .user_info_age{
    margin: 0 0 0 16px;
    font-size: 14px;
    color: #000000;
  }

  .user_info_phone{
    margin: 0 0 0 16px;
    font-size: 14px;
    color: #000000;
  }
  .user_right{
    display: flex;
    flex-shrink: 0;
    align-items: center;
    .radio_group{
      display: flex;
      align-items: center;
      height: 36px;
      text-align: center;
      border: 1px solid #E0E0E0;
      box-sizing: border-box;
      background: #fff;
      padding: 0 12px;
      border-radius: 4px;
    }
  }
  .user_formula{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    height: 36px;
    font-size: 14px;
    color: #000000;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    margin-left: 8px;
  }

  .handle{
    margin: 16px 0 0 0;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    overflow: hidden;
  }

  .handle_item{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
  }

  .handle>.handle_item:not(:first-child){
    border-top: 1px dashed #D3D3D5;
  }

  .handle_item_label{
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 30px;
    height: 100%;
    font-size: 14px;
    color: #000000;
  }

  .handle_item_value{
    flex-grow: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 24px;
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #000000;
  }

  .handle_refund{
    box-sizing: border-box;
    margin: 0 0 0 6px;
    padding: 0 2px;
    height: 18px;
    line-height: 14px;
    font-size: 12px;
    color: #F54A45;
    border: 1px solid #F54A45;
    border-radius: 2px;
  }

  .handle_item_order{
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 120px;
    height: 100%;
  }

  // 物流信息
  .handle_item.transport-info {
    margin-top: -14px;
    padding-left: 66px;
    font-size: 14px;
    border-top: none!important;
  }

  .order_text{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .order_text_empty{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .order_text_empty_icon{
    font-size: 14px;
    color: #1890FF;
  }

  .order_text_empty_text{
    margin: 0 0 0 3px;
    font-size: 14px;
    color: #1890FF;
    cursor: pointer;
  }

  .order_text_order{
    font-size: 14px;
    color: #000000;
  }

  .order_input{
    width: 100%;
  }

  .order_input /deep/ .el-input__inner{
    padding: 0;
    text-align: right;
    border: none;
  }

  .prescription{
    margin: 16px 0 0 0;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    overflow: hidden;
  }

  .prescription_table /deep/ th {
    background-color: #FFFFFF;
    padding: 8px 0;
  }

  .prescription_table /deep/ .prescription_table_header_default .cell{
    font-weight: bold;
    font-size: 14px;
    color: #667182;
  }
  .prescription_table /deep/ .prescription_table_header_keynote .cell{
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .prescription_table /deep/ .el-table__row .prescription_table_cell{
    font-size: 14px;
    color: #667182;
    padding: 8px 0;
  }

  .prescription_table /deep/ .el-table__row .prescription_table_cell.keynote{
    font-size: 14px;
    color: #1F2329;
  }

  .prescription_table /deep/ .el-table__row .prescription_table_cell:first-child{
    border-bottom: 1px dashed #E0E0E0;
  }

  .prescription_table /deep/ .el-table__row .prescription_table_cell:not(:first-child){
    border-left: 1px dashed #E0E0E0;
    border-bottom: 1px dashed #E0E0E0;
  }

  .prescription_parameter{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
  }

  .prescription_parameter_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    color: #000000;
  }

  .prescription_parameter_left_list{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    color: #000000;
  }

  .prescription_parameter_right{
    font-size: 14px;
    color: #000000;
  }

  .prescription_remarks{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    min-height: 40px;
    background-color: #FFFFFF;
    border-top: 1px solid #E0E0E0;
    overflow: hidden;
  }

  .prescription_remarks_label{
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 96px;
    font-size: 14px;
    color: #667182;
  }

  .prescription_remarks_value{
    flex-grow: 1;
    box-sizing: border-box;
    padding: 10px 12px;
    width: 100%;
    line-height: 20px;
    font-size: 14px;
    color: #1F2329;
    border-left: 1px solid #E0E0E0;
  }

  .other{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 16px 0 0 0;
    width: 100%;
    min-height: 40px;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    overflow: hidden;
  }

  .other_label{
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 96px;
    font-size: 14px;
    color: #667182;
  }

  .other_value{
    flex-grow: 1;
    box-sizing: border-box;
    padding: 10px 12px;
    width: 100%;
    line-height: 20px;
    font-size: 14px;
    color: #1F2329;
    border-left: 1px solid #E0E0E0;
  }
  .refund-icon{
      border: 1px solid #F54A45;
      color: #F54A45;
      font-size: 13px;
      padding: 0 2px;
      border-radius: 2px;
      margin-left: 4px;
  }

  .trace-item {
    display: inline-block;
  }

  .trace-item-empty {
    color: #A4AFBA;
  }

  
  /*
     物流信息样式
  */ 
  .transport-detail {
    position: relative;
    padding: 0 12px 12px;
    box-sizing: border-box;
    width: 100%;
    max-height: 400px;
    font-size: 14px;
    overflow-y: auto;
  }

  .transport-detail-title {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 2;
    padding: 12px 0 4px;
    color: #000000;
    background: #FFFDE9;
  }

  .transport-detail-title .icon {
    margin-left: 10px;
    color: #8892A3;
    cursor: pointer;
    transform: rotate(180deg);

    &:hover,&.active {
      color: #1890FF;
    }
  }

  // 物流step
  .transport-detail-content {
    color: #8892A3;
  }

  .transport-detail-content-item {
    position: relative;
    padding: 6px 0 0 20px;
    &:nth-child(1) {
      color: #1890FF;
      &:before {
        background-color: #1890FF;
      }
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 10px;
      z-index: 1;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #CCD4DC;
    }
    &:after {
      content: '';
      position: absolute;
      left: 4px;
      top: 10px;
      z-index: 0;
      width: 2px;
      height: 100%;
      background-color: #CCD4DC;
    }
  }

  .transport-detail-content-item-time {
    margin-top: 2px;
    font-size: 12px;
  }

</style>

<style>
  .el-popover.formula_popover.transport-popover {
    padding: 0!important;
  }
</style>